declare var $: any;

import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, DoCheck, OnInit,ElementRef,ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { appConstants } from 'src/app/common-service/const.model';
import { HelperService } from 'src/app/common-service/helper.service';
import { SignupService } from 'src/app/common-service/signup.service';
import { encryptionService } from '../../../app/common-service/cedService';
import { PasswordStrengthValidator } from '../../../app/usermgt/Models/pwdpolicy';
import { MustMatch } from 'src/app/usermgt/services/mustMatch';
import { takeUntil } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { StudentAdmissionService } from 'src/app/college/studentadmission/services/student-admission.service';
import { UidrService } from 'src/app/uidr/uidr.service';
import { LegalServicesService } from 'src/app/legal/services/legalServices.service';
import { ServerURLService } from 'src/app/common-service/serverURL.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { EncrDecrService } from 'src/app/common-service/EncrDecrService';
import { UsrmgtService } from 'src/app/usermgt/services/usrmgt.service';
import { Subject } from 'rxjs';
import { AcademicYearService } from 'src/app/common-service/academic-year.service';
import { FqsrCertificateService } from 'src/app/fqsr-certificate/fqsr-certificate-service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit, DoCheck {
  @ViewChild('openModal') openBtn: ElementRef<HTMLElement>;
  subscribe: Subject<any> = new Subject<any>();

  roleName: string;
  userName: string;
  previlizesList: any = [];
  advocateDetails: any = [];
  selectedRole: any;
  userData: any;
  owner: string;
  totalSeconds: any = 0;
  intervalId: any;
  roleList: any;
  refreshToken: any;
  urlInfo: any;
  ecSidenav = [];
  ecSubsidenav = [];
  InsCell = [];
  InsCellForSecretaryIncharge=[];
  InsCellForSecretary=[];
  InspCellForChairperson=[];
InspCellForInspectionExecutive=[];
  Insproforma = [];
  InsCellForAcademic= [];
  InsCellForPDMS= [];
  InspSec= [];
  InspCellForPresident=[];
  InsCellForSeverExecutive= [];
  InsCellForAcccount= [];
  travelAgent = [];
  showBread = false;
  changePasswordForm: FormGroup;
  eyeShowForConform = false;
  showConformPassword = false;
  showOldPassword = false;
  eyeShowForOld = false;
  showNewPassword = false;
  eyeShowForNew = false;
  designation: any;
  collegeName: any;
  pwdStatus:boolean;
  notificationCount;
  showNotificationIcon = false;
  editpermission:any =true;
  noteCount;
  academicYear: any;
  courseIdBDS: any;
  courseIdMDS: any;
  courseIdPGDiploma: any;
  showAddStudentBDS: boolean;
  showAddStudentMDS: boolean;
  showAddStudentPGDiploma: boolean;
  showFqsrRequest: boolean;
  userId: any;
  user: any;
  access: boolean;
  emailId: any;
  deg: any;
  conductInspCourse: any;
  entityId: any;
  collegeDetails: any;
  collegeId:any;
  currentDateAcademicYearDto: any;

  private config: {versionnew: string};
  constructor(public fb: FormBuilder, public router: Router, public signin: SignupService,
    public helper: HelperService, public ced: encryptionService, public appConst: appConstants, 
    private toastrSvc: ToastrService, public studentService: StudentAdmissionService, public uidrService: UidrService, 
    public legalService: LegalServicesService,private httpClient: HttpClient, public serverURL: ServerURLService,
     public spinner: NgxSpinnerService, public EncrDecr: EncrDecrService, public usrmgtService: UsrmgtService, 
     public academicYearService: AcademicYearService, public fqsrCertificateService: FqsrCertificateService) { }

  ngOnInit(): void {
    this.startTime();
    this.helper.sendDataToNotificationComponent(false);
    
    this.ecSidenav = this.appConst.ecSidenav;
    this.ecSubsidenav = this.appConst.ecSubsidenav;
    this.InsCell = this.appConst.InsCell;
    this.Insproforma= this.appConst.Insproforma;
    this.InsCellForAcademic = this.appConst.InsCellForAcademic;
    this.InsCellForPDMS = this.appConst.InsCellForPDMS;

      this.InspCellForPresident=this.appConst.InspCellForPresident
    this.InspSec = this.appConst.InspSec;
    this.InsCellForSeverExecutive = this.appConst.InsCellForSeverExecutive;
    this.InsCellForSecretaryIncharge=this.appConst.InsCellForSecretaryIncharge;
        this.InspCellForChairperson=this.appConst.InspCellForChairperson;
      this.InsCellForSecretary=this.appConst.InsCellForSecretary
        this.InspCellForInspectionExecutive=this.appConst.InspCellForInspectionExecutive;

    this.InsCellForAcccount = this.appConst.InsCellForAcccount;
    this.travelAgent = this.appConst.travelAgent;
    if ((!this.router.url.includes('/excu/ec/caseitem'))) {
      this.showBread = true;
    }
    this.conductInspCourse = sessionStorage.getItem('conduct-insp-course');
    this.owner = JSON.parse(sessionStorage.getItem('userInfo-usec')).useName;
    this.userData = JSON.parse(sessionStorage.getItem('userInfo-usec')).defaultRole;
    this.user = JSON.parse(sessionStorage.getItem('userInfo-usec')).userId;
    this.roleList = JSON.parse(sessionStorage.getItem('userInfo-usec')).rolesList;
    this.roleName= sessionStorage.getItem('selectedRole-usec');
    this.emailId = JSON.parse(sessionStorage.getItem('userInfo-usec')).emailId;
    this.deg = JSON.parse(sessionStorage.getItem('userInfo-usec')).deg;    
    this.designation = JSON.parse(sessionStorage.getItem('userInfo-usec'))?.deg?.designationName;
    this.userId = JSON.parse(sessionStorage.getItem('userInfo-usec')).userId;
    this.collegeName = sessionStorage.getItem('entity-master');
    if(this.roleName==='AcademicIncharge' || this.roleName==='AcademicAsstSecty' 
    || this.roleName==='AcademicSectionOfficer' || this.roleName==='AcademicAssistantSectionOfficer'
    || this.roleName==='AcademicExecutive' || this.roleName==='ServerSecExecutive' 
    || this.roleName==='System Admin')
    this.collegeId=sessionStorage.getItem('SAR-collegeId');
    if (this.roleList.length !== 0) {
      this.roleList.forEach(element => {
        // if (element.roleName === this.userData.roleName) {
        //   this.selectedRole = element.roleName;
        //   sessionStorage.setItem('selectedRole-usec', this.selectedRole);
        //   element.authorities.forEach(privi => {
        //     this.previlizesList.push(privi.authorityName);
        //   });
        // }
        
        // Added by Kannan for Role issue
        if (element.roleName === this.roleName) {
           this.selectedRole = this.roleName;
            sessionStorage.setItem('selectedRole-usec', this.selectedRole);
            element.authorities.forEach(privi => {
              this.previlizesList.push(privi.authorityName);
            });
          }

      });
    }
    // verify pwd status by kannan
    this.getPwdStatus();
    // this.academicYear = this.academicYearService.getCurrentAcademicYearMar();

    if(this.roleName === 'College Principal' || this.roleName === 'College Representative') {
      this.getCurrentDateAcademicYear();
      setTimeout(() => {
        this.getCollegeDetails();
      }, 300);
    }

    if(this.roleName==='Advocate'){

      this.legalService.advocateDetailsByUserId(this.user).subscribe((result: any) => {
        this.advocateDetails=result;
        if(this.advocateDetails.profileCompleted==false){
          this.access=false;
        } else if(this.advocateDetails.profileCompleted==true){
          this.access=true;
        }

         }, error => {
            console.log(error);
         });
     
    }

    if(this.roleName === 'Student') {
       this.getActiveFqsrApplicationCount();
    }
   // this.isAlreadyUIDRExist();  

    $('.sidebar-dropdown > a').click(() => {
      $('.sidebar-submenu').slideUp(200);
      if (
        $(this)
          .parent()
          .hasClass('active')
      ) {
        $('.sidebar-dropdown').removeClass('active');
        $(this)
          .parent()
          .removeClass('active');
      } else {
        $('.sidebar-dropdown').removeClass('active');
        $(this)
          .next('.sidebar-submenu')
          .slideDown(200);
        $(this)
          .parent()
          .addClass('active');
      }
    });

    const x = window.matchMedia('(max-width: 762px)');
    this.myFunction(x);

    // tslint:disable-next-line: deprecation
    x.addListener(this.myFunction);
    this.changePasswordForm = this.fb.group({
      oldPwd: ['', Validators.compose([Validators.required])],
      newPwd: ['', Validators.compose([Validators.required, PasswordStrengthValidator, Validators.minLength(8)])],
      confirmNewPwd: ['', Validators.compose([Validators.required])]
    }, {
      validator: MustMatch('newPwd', 'confirmNewPwd')
    });  
  }
  ngDoCheck(): void {
    //Called every time that the input properties of a component or a directive are checked. Use it to extend change detection by performing a custom check.
    //Add 'implements DoCheck' to the class.
    this.roleName = sessionStorage.getItem('selectedRole-usec');
    this.designation = JSON.parse(sessionStorage.getItem('userInfo-usec'))?.deg?.designationName;

    //this.notificationCount = sessionStorage.getItem('notificationCount');


  //   this.config = require('../../../../tsconfig.json');
  //   const headers = new HttpHeaders()
  //     .set('Cache-Control', 'no-cache')
  //     .set('Pragma', 'no-cache'); 
      
  //   this.httpClient
  //     .get<{ versionold: string }>("assets/tsconfig1.json", {headers})
  //     .subscribe(config => {
  //       if (config.versionold !== this.config.versionnew) {
  //         location.reload();
  //         // this.httpClient
  //         //   .get("/login", { headers, responseType: "text" })
  //         //   .subscribe(() => location.reload());
  //       }
  //     });

  }

  myFunction(x) {
    if (x.matches) { // If media query matches
      $('.page-wrapper').removeClass('toggled');
      $('#show-sidebar').click(() => {
        $('.page-wrapper').addClass('toggled');
      });

      $('#close-sidebar').click(() => {
        $('.page-wrapper').removeClass('toggled');
      });

    } else {
      $('.page-wrapper').addClass('toggled');
      $('#show-sidebar').click(() => {
        $('.page-wrapper').addClass('toggled');
      });

      $('#close-sidebar').click(() => {
        $('.page-wrapper').removeClass('toggled');
      });
    }
  }


  updateSeconds() {
    ++this.totalSeconds;
    this.stopTime();
  }

  startTime() {
    this.updateSeconds();
    this.intervalId = setInterval(() => {
      this.updateSeconds();
    }, 1000);
  }

  stopTime() {
    if (this.totalSeconds === 1100) {
      if (sessionStorage.getItem('userValue') !== null) {
        clearInterval(this.intervalId);
        this.refreshToken = this.ced.decryptingProcess('refresh-token');
        this.signin.getAccessTokenByRefreshToken(this.refreshToken).subscribe((res: any) => {
          this.ced.encryptingProcess('access-token', res.access_token);
          this.ced.encryptingProcess('refresh-token', res.refresh_token);
        });
      }
    }
  }

  profileClick(){
    this.legalService.advocateDetailsByUserId(this.user).subscribe((result: any) => {
      this.advocateDetails=result;
       }, error => {
          console.log(error);
       });

    //this.router.navigate(['/main/internal/legal/AdvocateProfileComponent/78']);
    this.router.navigate(['/main/internal/legal/AdvocateProfileComponent/', this.advocateDetails.advocateId]);

  }
  // ROle Change
  roleSelected() {
    this.roleList.forEach(element => {
      if (element.roleName === this.selectedRole) {
        this.roleName = this.selectedRole;
        this.selectedRole = element.roleName;
        sessionStorage.setItem('selectedRole-usec', this.roleName);
        
        this.signin.getSectionByRole(this.roleName).subscribe((res: any) => {
          
          const obj = {
            defaultRole: this.userData,
            rolesList: this.roleList,
            useName: this.owner,
            deg: this.deg,
            section: res.section,
            userId: this.user,
            emailId: this.emailId
          };
          
          sessionStorage.setItem('userInfo-usec', JSON.stringify(obj));
        });
        this.changeRoleAuditLog();
        this.helper.sendNotification(this.roleName);
        this.router.navigate(['/main/internal/dashboard']);
        this.router.onSameUrlNavigation = 'reload';
        element.authorities.forEach(privi => {
          // this.privilizeName = privi.authorityName;
          this.previlizesList.push(privi.authorityName);
        });
      }
    });
  }
  // reset
  reset() {
    this.changePasswordForm.reset();
  }
  // updatePassword
  // updatePassword() {
  //   this.signin.checkCurrentpwd(this.changePasswordForm.value.oldPwd).subscribe((res: any) => {
  //     if (res.matches === false) {
  //       this.pwdUpdateFailedAuditLog();
  //       this.toastrSvc.error('', 'Please Check Old Password');
  //       this.changePasswordForm.reset();
  //       this.openBtn.nativeElement.click();
  //     } else {
  //       const obj = {
  //         "currentPassword": this.changePasswordForm.value.oldPwd,
  //         "newPassword": this.changePasswordForm.value.newPwd
  //       }
        
  //       this.signin.changePassword(obj).subscribe((res: any) => {
          
  //         // update pwd status by Kannan
  //         this.updatePwdStatus();
  //         this.toastrSvc.success('', 'Password Changed Successfully');
  //         this.logoutAuditLog();
  //       })
  //     }
  //   })
  // }
  public eyeToggelForOldPassword() {
    this.showOldPassword = !this.showOldPassword;
    this.eyeShowForOld = !this.eyeShowForOld;
  }
  public eyeToggelForNewPassword() {
    this.showNewPassword = !this.showNewPassword;
    this.eyeShowForNew = !this.eyeShowForNew;
  }
  public eyeToggelForComformPassword() {
    this.showConformPassword = !this.showConformPassword;
    this.eyeShowForConform = !this.eyeShowForConform;
  }
  // Logout
  logout() {
    this.clearSession();
  }

  clearSession() {
    sessionStorage.clear();
    localStorage.clear();
  }

  logoutAuditLog() {
    this.signin.getLogoutAuditLog().subscribe((res: any) => {
      this.signin.deleteOauthTokenLogout().subscribe((result: any) => {      
      });      
    },
    error => {
     console.log(error);
    });
  }

  // Get pwd status
  getPwdStatus() {
    const obj = {
      emailId: this.ced.encryptAesToString(sessionStorage.getItem('email-Id'), this.serverURL.secretKey).toString()
    }
    this.signin.getPwdStatus(obj).subscribe((res: any) => {
      this.pwdStatus = res;
      if(!res){
        this.openBtn.nativeElement.click();
      }
    }, error => {
			console.log(error);
			this.helper.errorMessage(error);
		});
  }
  keyPresshas(event: any) {
    if (event.keyCode == 35) {
      event.preventDefault();
    }
  }

  // Update pwd status
  updatePwdStatus() {
    const obj = {
      emailId: this.ced.encryptAesToString(sessionStorage.getItem('email-Id'), this.serverURL.secretKey).toString()
    }
    this.signin.updatePwdStatus(obj).subscribe((res: any) => {
      console.log("Password updated  "+res);
    });
  }

  pwdUpdateFailedAuditLog() {
    this.signin.setPwdUpdateFailedAuditLog().subscribe((result: any) => {
      
    });
  }

  isAlreadyUIDRExist()
  {
    this.uidrService.IsAlreadyUIDRExist( sessionStorage.getItem('userId-usec')).pipe().subscribe((result: any) => {
     
      this.editpermission = result;
      
    }, error => {
      console.log(error);
    });
  }

   // Get pwd status
   getStudentAdmissionPeriod() {
      this.courseIdBDS = 1;
      this.studentService.getStudentAdmissionPeriod(this.academicYear, this.courseIdBDS).subscribe((res: any) => {
        
      if ((res === null || res.totalCount === null || res.totalCount === 0) && 
      (this.roleName === 'College Principal' || this.roleName === 'College Representative')) {
          this.showAddStudentBDS = false;
        } else {
          this.showAddStudentBDS = true;
        }
      });

      this.courseIdMDS = 2;
      this.studentService.getStudentAdmissionPeriod(this.academicYear, this.courseIdMDS).subscribe((res: any) => {
        
        if ((res === null || res.totalCount === null || res.totalCount === 0) && 
        (this.roleName === 'College Principal' || this.roleName === 'College Representative')) {
          this.showAddStudentMDS = false;
        } else {
          this.showAddStudentMDS = true;
        }
      });
  }

  conductInspection() {
    sessionStorage.setItem('conduct-insp-course', '');
  }

  changeRoleAuditLog() {
    this.signin.changeRoleAuditLog().subscribe((result: any) => {      
    });
  }

  addNewStudent() {    
    this.entityId = sessionStorage.getItem('entityId-usec');
    var encryptedEntityId = this.EncrDecr.set(this.serverURL.secretKey, this.entityId);   
    this.router.navigate(['/main/internal/college/dean/addStudentForm/0/', encryptedEntityId]);
  }

  ministry() {
    var encrypted = this.EncrDecr.set(this.serverURL.secretKey, "304");
    this.router.navigate(['main/internal/mdm/common/ministry/', encrypted]);
  }

   // updatePassword
   updatePassword() {
        const obj = {          
          "currentPassword": this.ced.encryptAesToString(this.changePasswordForm.value.oldPwd, this.serverURL.secretKey).toString(),
          "newPassword": this.ced.encryptAesToString(this.changePasswordForm.value.newPwd, this.serverURL.secretKey).toString(),
        }        
        this.spinner.show();
        this.signin.changePassword(obj).subscribe((data: any) => {
          this.spinner.hide();
          if (data.response.respcode === '500') {
            this.toastrSvc.error('', 'Please Check Old Password');
            this.changePasswordForm.reset();
            this.openBtn.nativeElement.click();
          } else {
            // update pwd status by Kannan
            this.updatePwdStatus();
            this.toastrSvc.success('', 'Password Changed Successfully');
            this.logoutAuditLog();
          }          
        }, error => {
          this.spinner.hide();
          console.log(error);
        });
  }
  
  getCollegeDetails() {
    this.spinner.show();
    this.usrmgtService.getCollegeDetails().pipe(takeUntil(this.subscribe)).subscribe(res => {      
      this.collegeDetails = res;
      this.spinner.hide();
    }, error => {
      this.spinner.hide();
      console.log(error);
    });
  }

  // getActiveFqsrApplicationCount
  getActiveFqsrApplicationCount() {
    this.fqsrCertificateService.getActiveFqsrApplicationCount().subscribe((res: any) => {      
    if (res !== null) {
        this.showFqsrRequest = res?.showFqsrRequest;
      } else {
        this.showFqsrRequest = false;
      }
    });
}

 // Current Date and Format
 public getCurrentDateAcademicYear() {    
  this.usrmgtService.getCurrentDateAcademicYear().pipe(takeUntil(this.subscribe)).subscribe(res => {
    this.currentDateAcademicYearDto = res;
    this.academicYear = this.ced.decryptAesformString(this.currentDateAcademicYearDto?.academicYear, this.serverURL.secretKey);
    this.getStudentAdmissionPeriod();
  }, error => {
    console.log(error)
  });
}

}
